/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets SDSurveyQuestionOptionsResponseStruct from api:
 * /v1/ua/survey_questions
 *
 * @param {string} language.
 * @param {any} callback function to call once this function has finished
 */
const fetchSurveyQuestionsUtil = (language, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/survey_questions?language=${language}`,
    models.SDSurveyQuestionOptionsResponseStruct
  );
};

/**
 * Post request to path:
 * /v1/ua/survey_answers
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postSurveyAnswersUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/survey_answers`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

export { fetchSurveyQuestionsUtil, postSurveyAnswersUtil };
